import {TRANSFORM_TYPES, URL_TYPES} from './constants.js'
import {
  getCurrentSource,
  getFastlyDeviceCropSource,
  getFastlyOriginalSource,
  getPincherDeviceCropSource,
  getPrecfMediaDeviceCropSource,
  getProFastlyDeviceCropSource,
  getYamsDeviceCropSource,
  getYamsOriginalSource
} from './utils.js'

// Re-export constants so existing consumers (which import from config.js) keep working.
export {
  ASPECT_RATIO_TYPES,
  DEFAULT_ASPECT_RATIO,
  DEFAULT_OPTIONS,
  IMAGE_TYPES,
  TRANSFORM_TYPES,
  URL_TYPES
} from './constants.js'

const yamsAdapter = {
  [TRANSFORM_TYPES.DEVICE_CROP]: getYamsDeviceCropSource,
  [TRANSFORM_TYPES.ORIGINAL]: getYamsOriginalSource
}

const fastlyAdapter = {
  [TRANSFORM_TYPES.DEVICE_CROP]: getFastlyDeviceCropSource,
  [TRANSFORM_TYPES.ORIGINAL]: getFastlyOriginalSource
}

const pincherAdapter = {
  [TRANSFORM_TYPES.DEVICE_CROP]: getPincherDeviceCropSource,
  [TRANSFORM_TYPES.ORIGINAL]: getCurrentSource
}

const otherAdapter = {
  [TRANSFORM_TYPES.DEVICE_CROP]: getCurrentSource,
  [TRANSFORM_TYPES.ORIGINAL]: getCurrentSource
}

const proFastlyAdapter = {
  [TRANSFORM_TYPES.DEVICE_CROP]: getProFastlyDeviceCropSource,
  [TRANSFORM_TYPES.ORIGINAL]: getCurrentSource
}

const precfMediaAdapter = {
  [TRANSFORM_TYPES.DEVICE_CROP]: getPrecfMediaDeviceCropSource,
  [TRANSFORM_TYPES.ORIGINAL]: getCurrentSource
}

export const PROVIDER_ADAPTERS = {
  [URL_TYPES.OTHER]: otherAdapter,
  [URL_TYPES.PINCHER]: pincherAdapter,
  [URL_TYPES.YAMS]: yamsAdapter,
  [URL_TYPES.FASTLY]: fastlyAdapter,
  [URL_TYPES.PRO_FASTLY]: proFastlyAdapter,
  [URL_TYPES.PRECF_MEDIA]: precfMediaAdapter
}
